import { Avatar, SxProps } from '@mui/material';
import React, { useMemo } from 'react';
import { BucketImage, useBucketImage } from '../../../hooks/useBucketImage';
import { UserProfile } from '../../../types/user';

const ProfilePicture = ({
	profile,
	onClick,
	image,
	sx,
	className
}: {
	profile?: Partial<UserProfile> | null;
	onClick?: React.MouseEventHandler;
	image?: BucketImage;
	sx?: SxProps;
	className?: any;
}) => {
	const { src } = useBucketImage(image);

	const letters = useMemo(() => {
		if (profile?.firstName && profile?.lastName) {
			return `${profile.firstName.charAt(0)}${profile.lastName.charAt(0)}`;
		}
		return profile?.email?.charAt(0);
	}, [profile]);

	return (
		<Avatar aria-label="user avatar" className={className} onClick={onClick} src={src} sx={sx}>
			{letters}
		</Avatar>
	);
};

export default ProfilePicture;
